<i18n src="../../../locales/lang.json"></i18n>

<template>
  <div class="card" v-bind:id="getId()" style="float:left; width:200px; margin-left:15px;">
    <div class="card-header bg-dark text-white header-elements-inline">
      <h6 class="card-title">{{config.text}}</h6>
      <div class="header-elements">
        <div class="list-icons">
          <a class="list-icons-item" @click="removeMe" data-action="remove"></a>
        </div>
      </div>
    </div>
    <div class="card-body text-center card-img-top p-0">
      <div style="position:relative;height:189px;display:block;width:170px">
        <gmaptest ref="map" v-bind:zoomlevel="13"></gmaptest>
        <div style="position:absolute;z-index:100000;top:10px;left:10px">
          <div class="card-img-actions d-inline-block mb-0">
            <img class="img-fluid rounded-circle" src="/images/user_200x200.jpg" alt="" width="40" height="40">
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
  var config =
  {
    customstyle: "background-color:#92D050",
    customclass: "",
    abbreviation: "T1",
    data: 8,
    text: "Team 1",
    icon: null
  }

  var name = "";
  var latLong = null;

  export default {
    name: "display-user",
    components: {

    },
    props: {
      enableedit: {
        required: false,
        type: String,
        default: "false"
      },
      type: {
        required: false,
        type: String,
        default: ""
      },
    },
    data() {
      return {
        config,
        name,
        latLong
      };
    },

    methods: {
      getId() {
        return "child_" + this._uid;
      },
      toggleActivation() {

      },
      handleRefresh(val) {
        this.$forceUpdate();
      },
      removeMe() {
        this.$emit('remove', this.getId());
      },
      setConfig(config) {
        this.config = config;
        this.loadData();
      },
      loadData() {
        try {
          var url = '/api/Membership/GetSiteUser?username=' + this.config.data;
          this.$http.get(url).then(async response => {
            this.Name = response.data.Name;
            this.latLong = response.data.LatLong;
            if (this.latLong != null) {
              this.$refs.map.setCenter(parseFloat(this.latLong.split(',')[0]), parseFloat(this.latLong.split(',')[1]));
            }
          });
        }
        catch (err) {
          alert('some error:' + err)
        }
      }
    },
    computed: {

    },
    mounted() {
      vm.$root.$on('statistics', this.recalculate);
      //alert('doSearch13')
      vm.$emit('doSearch');
    },

    created: function () {

    },

    watch: {

    },
    created() {
      //this.$root.$on('procedure_refresh', this.handleRefresh);
    },
  };

</script>

<style scoped>

  .card-header.bg-dark {
    background-color: #f6f7f7 !important;
    color: black !important;
    padding-left: 10px;
    padding-right: 10px;
    padding-top: 5px;
    padding-bottom: 5px;
  }

  .link-btn {
    color: #EAEDEF !important;
    border-color: #EAEDEF !important;
  }

  @media screen and (max-width:768px) {
    .card {
      margin-left: 5px !important;
      width: 185px !important;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/filter/displayers/display-user.vue